import { IMAGE, IMAGE_DESKTOP, IMAGE_MOBILE } from '../elements/assets'
import { LINK_FIELD } from '../elements/link'

export const ONEBOARD_GUIDE = `
...on oneboardGuide_Entry {
  id
  typeHandle

  darkMode
  heading {
    html
  }
    
  oneboardGuideContent {
    ... on oneboardGuideContent_Entry {
      id

      onboardTabs {
        ... on onboardCarousel_Entry {
          id
          typeHandle
          tabName
          title
          description

          ${ LINK_FIELD }

          onboardCarouselSlides {
            ... on onboardCarouselSlide_Entry {
              id
              title
              
              ${ IMAGE }
            }
          }
        }

        ... on onboardTab_Entry {
          id
          tabName
          typeHandle
          title
          description
          
          ${ IMAGE_DESKTOP }
          ${ IMAGE_MOBILE }

          ${ LINK_FIELD }
        }
      }
    }
  }
}
`